import { Link, useLocation } from "react-router-dom";

const MultiStep = ({ steps, currentStep,from="register" }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const stepsStatus = JSON.parse(localStorage.getItem("stepsStatus")) || [];
    // console.log({from})
  // Filter steps where display is true (or if display property doesn't exist, include it)
  const filteredSteps = steps?.filter(step => step.display !== false);

  // Function to check if current path matches any of the step's paths
 
  const isStepActive = (step) => {
    // Normalize path by removing trailing slashes and dynamic segments
    const normalizePath = (path) => {
      if (typeof path === 'string') {
        return path.replace(/\/:.*$/, '').replace(/\/$/, '');
      }
      return path;
    };
  
    const currentBasePath = normalizePath(currentPath);
    
    if (Array.isArray(step.paths)) {
      return step.paths.some(path => {
        const normalizedStepPath = normalizePath(path);
        return currentBasePath === normalizedStepPath;
      });
    }
    
    return currentBasePath === normalizePath(step.path);
  };
  return (
    <div className="container d-flex justify-content-center align-items-center mt-32">
      <ul className="nav customnowrap">
        {filteredSteps?.map((step, index) => {
          const stepStatus = stepsStatus[step.step];
          const isPassed = stepStatus === "completed" || stepStatus === "passed";
          const isNotPassed = from==='reservation' || from==='facturation' ? false : stepStatus === "passed";

          // Check if current step is active (handles both single path and multiple paths)
          const stepActive = step.step===currentStep
          const prevStep= currentStep > step.step;

          return (
            <li
              key={Array.isArray(step.paths) ? step.paths[0] : step.path}
              className="nav-item d-flex align-items-center justify-content-center"
            >
              <div
                className={`step body bold500 d-flex justify-content-center align-items-center mr-8
                  ${isNotPassed ? 'not-passed':
                    stepActive
                      ? "bold500 grey500 step-active"
                      : "grey66"
                  }`}
              >
                {isNotPassed ? (
                  <img
                    src="/images/notPassed.svg"
                    alt="alert icon"
                    className="not-Passed"
                  />
                ) : currentStep > step.step ? (
                  <img src="/images/check-dark.svg" alt="check icon" />
                ) : (
                  step.step
                )}
              </div>
              <span
               
                className={`body tabTitle ${
                  stepActive ? "bold500 grey500" : "grey66"
                }`}
              >
                {step.label}
              </span>
              {index < filteredSteps.length - 1 && (
                <img
                  src="/images/RectanglePro.svg"
                  alt="separator"
                  className="mx-2"
                />
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MultiStep;